module.exports = "https://s91588.cdn.ngenix.net/reviews-frontend/_next/static/images/app_300_500_dark-b2695a0a96dbefa8bf1902f79040ede4.png";